import React from 'react'

import Firstsection from './Component/Firstsection'

import Fifthsection from './Component/Fifthsection'

import Footer from './Component/footer'
import { Element } from 'react-scroll'

function home() {
  
  return (
    <div>
    <Element  id='first' name='Service'> 
      <Firstsection />
      </Element>
      
      <Element  id='fifth' name='Service'> 
      <Fifthsection />
      </Element>
      

      <Element  id='contact' name='footer'> 
      <Footer />
      </Element>
      
    </div>
  )
}

export default home
